import React, { useState, useEffect } from 'react';
import './LocalSeoStoreView.scss';
import { 
    GoogleMapsIcon 
} from '../localSeoStoreChart/LocalSeoStoreChartIcons';
import translate from '../../../config/translations/translate';
import LocalSeoStoreContent from '../shared/LocalSeoStoreContent';
import { getLocalSeoStoreChartData, getLocalSEOTableData } from '../../../api/dashboardV2Api';
import { processChartData } from '../localSeoStoreChart/LocalSeoStoreChart';
import { formatStoreMetrics } from '../localSEOTable/localSEOTable';

const LocalSeoStoreViewComponent = ({store, selectedPeriod, t}) => {

    const [placeId, setPlaceId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [chartData, setChartData] = useState([]);
    const [keywordSearchCounts, setKeywordSearchCounts] = useState([]);

    useEffect(() => {
        if (!store || !store.id) return;
        
        const fetchChartData = async () => {
            setIsLoading(true);
            try {
                const res = await getLocalSeoStoreChartData(store.id, selectedPeriod);
                const processedChartData = processChartData(res.data.data, t);
                setChartData(processedChartData);
                setKeywordSearchCounts(res.data.data.keywordSearchCounts);
                
                if (res.data.data && res.data.data.placeId) {
                    setPlaceId(res.data.data.placeId);
                }
            } catch (error) {
                console.error('Error fetching chart data:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchChartData();
    }, [store && store.id, selectedPeriod]);

    useEffect(() => {
        if (!store || !store.id || !store.companyId) return;

        const fetchMetrics = async () => {
            try {
                const tableResponse = await getLocalSEOTableData(
                    store.companyId,
                    0,
                    selectedPeriod,
                    100,
                    'AVERAGE_RANKING_DESC'
                );

                if (tableResponse && 
                    tableResponse.data && 
                    tableResponse.data.data && 
                    tableResponse.data.data.locationRankingAndMetrics) {
                    
                    const storeData = tableResponse.data.data.locationRankingAndMetrics.find(
                        location => location.storeId === store.id
                    );

                    if (storeData) {
                        store.metrics = formatStoreMetrics(storeData);
                    }
                }
            } catch (error) {
                console.error('Error fetching metrics:', error);
            }
        };

        fetchMetrics();
    }, [store && store.id, store && store.companyId, selectedPeriod]);

    return (
        <div className="local-seo-store-view-container">
            <div className="local-seo-chart-header-container">
                <div className="local-seo-icon-and-subtitle">
                    <div className="google-maps-icon">
                        <GoogleMapsIcon />
                    </div>
                    <h4 className="google-maps-subtitle">{t('googleMapsRanking')}</h4>
                    {(placeId !== null) && <img src="/static/img/GooglePlaceIcon.svg" 
                                alt="Google Place Icon" 
                                style={{width: "30px", height: "30px", marginLeft: "10px", cursor: "pointer"}} 
                                onClick={() => {
                                    window.open(`https://www.google.com/maps/place/?q=place_id:${placeId}`, '_blank');
                                }}
                    />}
                </div>
            </div>
            <LocalSeoStoreContent 
                store={store}
                isLoading={isLoading}
                chartData={chartData}
                keywordSearchCounts={keywordSearchCounts}
                t={t}
            />
        </div>
    )
}

LocalSeoStoreViewComponent.translations = {
    googleMapsRanking: {
        es: "Ranking en Google Maps",
        en: "Google Maps Ranking"
    },
    months: {
        january: {
            es: "Enero",
            en: "January"
        },
        february: {
            es: "Febrero",
            en: "February"
        },
        march: {
            es: "Marzo",
            en: "March"
        },
        april: {
            es: "Abril",
            en: "April"
        },
        may: {
            es: "Mayo",
            en: "May"
        },
        june: {
            es: "Junio",
            en: "June"
        },
        july: {
            es: "Julio",
            en: "July"
        },
        august: {
            es: "Agosto",
            en: "August"
        },
        september: {
            es: "Septiembre",
            en: "September"
        },
        october: {
            es: "Octubre",
            en: "October"
        },
        november: {
            es: "Noviembre",
            en: "November"
        },
        december: {
            es: "Diciembre",
            en: "December"
        }
    },
    metrics: {
        visits: {
            es: "Visitas",
            en: "Visits"
        },
        walkIns: {
            es: "Visitas a la tienda",
            en: "Walk-ins"
        },
        websiteClicks: {
            es: "Clics al sitio web",
            en: "Website Clicks"
        },
        menuClicks: {
            es: "Clics al menú",
            en: "Menu Clicks"
        },
        orders: {
            es: "Pedidos",
            en: "Orders"
        },
        bookings: {
            es: "Reservas",
            en: "Bookings"
        },
        engagementRate: {
            es: "Tasa de interacción",
            en: "Eng. Rate"
        }
    },
    columns: {
        comparisonTooltip: {
            es: "Esta comparación muestra el porcentaje de cambio entre el período y el mismo período del año anterior.",
            en: "This comparison shows the percent of change between the period and the same period the year before."
        },
        noDataComparisonTooltip: {
            es: "Esta comparación no aplica, ya que no hay datos suficientes para el período anterior.",
            en: "This comparison does not apply, as there is not enough data for the previous period."
        }
    }
};

export const LocalSeoStoreView = translate(LocalSeoStoreViewComponent);